import { z } from 'zod';
export const RecommendedNextStepSchema = z.object({
    step: z.string(),
    priority: z.enum([
        'low',
        'medium',
        'high'
    ])
});
export const RecommendedNextStepsSchema = z.array(RecommendedNextStepSchema).meta({
    id: 'RecommendedNextSteps'
});

//# sourceMappingURL=recommended-next-steps.schema.js.map